import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from './index.module.scss';
import { products } from './config';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { Navigation } from 'swiper';

const ProductList: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang(`xcode.productlist`);
    const list = products[locale] || products.us;

    return (
        <div className={styled.ProductList} id="Products">
            <p className="title middle-central">{t('title')}</p>
            <div className="product_central">
                <Swiper
                    className="product_box"
                    modules={[Navigation]}
                    spaceBetween={30}
                    navigation
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {list.map((item, index) => (
                        <SwiperSlide className="product_item" key={index}>
                            <EditorImg className="img" pc={item.img} alt={t('title')} />
                            <p className="name">{item.name}</p>
                            <EditorLink className="btn" href={item.link} target="_blank">
                                {t('btn')}
                            </EditorLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default ProductList;
